import React, { useEffect } from 'react';
import '../cs/temp.css';
import AOS from "aos";
import "aos/dist/aos.css";

function CrmSoftware() {

useEffect(() => {
AOS.init({ duration: 1000, once: true });
}, []);


    return (
        <div className="webdev-page" style={{overflowX:"hidden"}}>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                >
                    <div className="container" data-aos="fade-up">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">CRM Software</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Services Section */}
            <section className="webdev-services-section">
                <div className="container">
                    <div className="section-header">
                        <h2 data-aos="fade-up">Our Cross Platform Development Services</h2>
                        <p className="section-description">
                        We develop powerful applications that run smoothly across multiple platforms and devices, ensuring a unified experience for every user. Our cross-platform solutions are designed to speed up development, lower costs, and deliver consistent performance without compromising on quality                        </p>
                    </div>

                    <div className="services-grid" data-aos="fade-up-left">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-mobile-alt"></i>
                            </div>
                            <h3>Multi-Platform Applications</h3>
                            <p>Create versatile applications from a single codebase, allowing your product to work on iOS, Android, Windows, and macOS while reducing development time and effort..</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-sync"></i>
                            </div>
                            <h3>Code Synchronization</h3>
                            <p>Maintain feature parity and design consistency across all platforms through well-structured code updates and synchronization.</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-cogs"></i>
                            </div>
                            <h3>Integration Services</h3>
                            <p>Seamlessly connect your application with APIs, enterprise systems, and third-party services to provide a connected and efficient digital experience.</p>
                        </div>

                        {/* <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-headset"></i>
                            </div>
                            <h3>Ongoing Support</h3>
                            <p>Ensure your application remains up-to-date and optimized across all platforms with our comprehensive support.</p>
                        </div> */}
                    </div>
                </div>
            </section>

           
           

            {/* Development Process Section */}
            <section className="design-process-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our Cross Platform Development Process</h2>
                        <p className="section-description">
                            A structured approach to delivering efficient, high-quality cross-platform applications
                        </p>
                    </div>

                    <div className="process-timeline">
                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>Requirements Analysis</h3>
                                <p>Understand your objectives, audience, and business requirements to outline the project scope.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>Technology Selection</h3>
                                <p>Select the right framework (React Native, Flutter, or Xamarin) tailored to your application’s needs.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>UI/UX Design</h3>
                                <p>Design intuitive, visually appealing interfaces that align with your brand and platform standards..</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3>Core Development</h3>
                                <p>Build a robust, shared codebase to power your app across all devices and operating systems.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">5</div>
                            <div className="step-content">
                                <h3>Platform-Specific Customization</h3>
                                <p>Add custom platform-specific functionality to enhance usability and performance.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">6</div>
                            <div className="step-content">
                                <h3>Testing & Quality Assurance</h3>
                                <p>Perform detailed testing to ensure flawless functionality, speed, and reliability on all platforms.</p>
                            </div>
                        </div>
                        
                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">7</div>
                            <div className="step-content">
                                <h3>Deployment</h3>
                                <p>Deploy your app across app stores and distribution channels with smooth rollout support..</p>
                            </div>
                        </div>
                        
                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">8</div>
                            <div className="step-content">
                                <h3>Support & Maintenance</h3>
                                <p>Offer ongoing updates, maintenance, and performance monitoring to keep your app current and effective.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

             {/* Who Can Benefit Section */}
             <section className="why-choose-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Who Can Benefit from Cross Platform Solutions?</h2>
                        <p className="section-description">
                            Our cross-platform applications provide value across industries and use cases, helping organizations reach wider audiences with efficient development.
                        </p>
                    </div>

                    <div className="features-grid" data-aos="fade-up-left" data-aos-delay="300">
                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-building"></i>
                            </div>
                            <h3>Startups & SMEs</h3>
                            <p>Launch faster, reduce costs, and reach customers on multiple devices from day one.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-shopping-cart"></i>
                            </div>
                            <h3>E-commerce Businesses</h3>
                            <p>Deliver a seamless shopping experience across mobile, web, and desktop platforms to increase conversions</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-users"></i>
                            </div>
                            <h3>Enterprise Organizations</h3>
                            <p>Build scalable internal tools and customer-facing apps that function consistently within your ecosystem.</p>
                        </div>

                        {/* <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-gamepad"></i>
                            </div>
                            <h3>Game Developers</h3>
                            <p>Develop games that run on multiple platforms without the need to rewrite code for each environment.</p>
                        </div> */}
                    </div>
                </div>
            </section>



            {/* CTA Section */}
            <section className="cta-section mt-5">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Expand Your Reach Across Platforms?</h2>
                        <p>Let's build a cross-platform solution that provides a consistent experience for all your users.</p>
                        <a href="/contact" className="cta-button">Get a Free Consultation</a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default CrmSoftware;
